import {connect} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'

import AccountSetupCompleteDialog from './AccountSetupCompleteDialog'

const mapDispatchToProps = {
  closeDialog: aCloseDialog,
}

export default connect(null, mapDispatchToProps)(AccountSetupCompleteDialog)

export const DIALOG_NAME = 'onboarding/account-setup-complete'
